"use strict";
// TODO: Create function applicators for words/characters to reduce boilerplate
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProcessedWord = function (processedInput) {
    return Array.isArray(processedInput);
};
exports.isProcessedCharacter = function (processedInput) {
    return !Array.isArray(processedInput);
};
exports.process = function (inputString) {
    var words = inputString
        .split(" ")
        .filter(function (word) { return word !== ""; })
        .map(function (word) { return word.split(""); });
    return words.map(function (word) {
        return word.map(function (character) {
            return {
                source: character,
                transformed: [character]
            };
        });
    });
};
exports.toString = function (stream) {
    return stream
        .map(function (word) { return word.map(function (char) { return char.transformed.join(""); }).join(""); })
        .join(" ");
};
